module.exports = __webpack_public_path__ + "img/vat_not_in_use.3d11a02f.svg";